import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { fazendaAction, tanqueAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import NavBar from '../_components/navbar';
import {
    Button, Container, Row, Col, Card, CardBody, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, UncontrolledTooltip
} from 'reactstrap';
import Select from 'react-select';
import Moment from 'react-moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlusCircle, faPen, faTrash, faSearch, faTimes, faChevronLeft, faChevronRight,
    faTint, faDollarSign, faChartLine, faCalendarAlt
} from '@fortawesome/free-solid-svg-icons';
import 'moment-timezone';

const Tanque = (props) => {

    const dispatch = useDispatch();
    const [, forceUpdate] = React.useState(0);
    const [modal, setModal] = useState(false);
    const [selectedFazenda, setSelectedFazenda] = useState('0');
    const [openTanques, setOpenTanques] = useState(false);
    const [periodo, setPeriodo] = useState('');

    // Pagination state
    const [page, setPage] = useState(1);
    const [limit] = useState(12);

    const { tanque } = props.tanque;

    useEffect(() => {
        dispatch(fazendaAction.getFazendaSelect(true));
    }, []);

    useEffect(() => {
        if (selectedFazenda && selectedFazenda !== '0') {
            dispatch(tanqueAction.getTanqueByFazenda(selectedFazenda, true));
        } else {
            dispatch(tanqueAction.clear());
        }
        setPage(1); // Reset page on fazenda change
    }, [selectedFazenda]);


    const handleChangePeriodo = (field) => (event) => {
        if (field === 'periodo') {
            setPeriodo(event.target.value);
        }
    };

    const handleClickOpenTanques = () => {
        setOpenTanques(true)
    };

    const handleCloseTanques = () => {
        setOpenTanques(false)
    };

    const setFile = (event) => {
        props.tanque.arquivo = event.target.files[0];
        forceUpdate();
    }

    const handleImportTanques = () => {
        if (props.tanque.arquivo === null || props.tanque.arquivo === '') {
            alert('Informe um Arquivo válido!');
        } else {
            var formData = new FormData();
            formData.append('periodo', periodo);
            formData.append('file', props.tanque.arquivo);

            dispatch(tanqueAction.importTanques(formData, true));
            setOpenTanques(false); // Close modal after import
        }
    };

    const handleSelectChange = prop => event => {
        if (prop === 'id_fazenda') {
            setSelectedFazenda(event.value);
        }
        var event2 = {
            type: 'select',
            target: { value: event.value }
        };
        dispatch(fazendaAction.onChangeProps(prop, event2));
    };

    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    // Client-side Pagination logic
    const filteredTanques = tanque ? tanque : [];
    const totalItems = filteredTanques.length;
    const totalPages = Math.ceil(totalItems / limit);
    const paginatedTanques = filteredTanques.slice((page - 1) * limit, page * limit);

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Tanques</h2>
                        <p className="text-muted mb-0">Gerencie os dados dos tanques da fazenda</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ minWidth: '250px' }}>
                            <Select
                                classNamePrefix="select"
                                value={renderOptionsFazenda().filter(option => option.value == (selectedFazenda || ''))}
                                onChange={handleSelectChange('id_fazenda')}
                                isSearchable
                                id="id_fazenda"
                                name="id_fazenda"
                                placeholder="Selecione a Fazenda..."
                                options={renderOptionsFazenda()}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderRadius: '50px',
                                        border: state.isFocused ? '1px solid var(--primary-color)' : '1px solid #e0e0e0',
                                        boxShadow: state.isFocused ? '0 0 0 0.2rem var(--primary-shadow)' : '0 2px 4px rgba(0,0,0,0.02)',
                                        paddingLeft: '10px',
                                        height: '45px',
                                        '&:hover': {
                                            border: state.isFocused ? '1px solid var(--primary-color)' : '1px solid #e0e0e0'
                                        }
                                    })
                                }}
                            />
                        </div>

                        {selectedFazenda !== '0' && (
                            <>
                                <Button
                                    id="btnImportar"
                                    color="primary"
                                    className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                                    style={{ borderRadius: '50px', fontWeight: '600', height: '45px' }}
                                    onClick={handleClickOpenTanques}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                                    <span className="text-nowrap">Importar</span>
                                </Button>
                                <UncontrolledTooltip placement="bottom" target="btnImportar">
                                    Importar dados de tanques via Excel
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                </div>

                {/* Grid Section */}
                {paginatedTanques.length > 0 ? (
                    <>
                        <Row>
                            {paginatedTanques.map((item, index) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={index}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column">

                                            <div className="d-flex align-items-center mb-4">
                                                <div className="d-flex justify-content-center align-items-center text-primary rounded-circle mr-3"
                                                    style={{ width: '50px', height: '50px', backgroundColor: 'var(--primary-light)' }}>
                                                    <FontAwesomeIcon icon={faCalendarAlt} size="lg" className="text-primary" />
                                                </div>
                                                <div>
                                                    <h5 className="mb-1 font-weight-bold text-dark">
                                                        <Moment format="DD/MM/YYYY">
                                                            {item.tanque.periodo}
                                                        </Moment>
                                                    </h5>
                                                    <Badge color="primary" className="px-2 py-1">
                                                        {item.tanque.vacas_lactacao} Animais
                                                    </Badge>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faTint} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Volume:</span>
                                                        <span className="font-weight-bold">{item.tanque.volume} L</span>
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faChartLine} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Média/Dia:</span>
                                                        <span className="font-weight-bold">{item.tanque.media_litros_dia} L</span>
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faDollarSign} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Faturamento:</span>
                                                        <span className="font-weight-bold text-success">
                                                            {new Intl.NumberFormat('pt-BR', {
                                                                style: 'currency',
                                                                currency: 'BRL',
                                                            }).format(item.tanque.faturamento)}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faTint} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhum registro encontrado</h4>
                            <p className="text-muted">Selecione uma fazenda ou realize uma importação.</p>
                        </Col>
                    </Row>
                )}
            </Container>

            {/* Import Modal */}
            <Modal isOpen={openTanques} toggle={handleCloseTanques} centered>
                <ModalHeader toggle={handleCloseTanques} className="border-0">Importação de Tanques</ModalHeader>
                <ModalBody>
                    <p className="text-muted mb-3">
                        O arquivo deve estar no formato Excel (.xls, .xlsx) ou CSV.
                        <br />
                        <a href="./modelo_importacao_tanques.csv" target="_blank" download className="font-weight-bold">
                            Baixar modelo de importação
                        </a>
                    </p>
                    <FormGroup>
                        <Label for="data" className="font-weight-bold">Período</Label>
                        <Input
                            id="data"
                            type="date"
                            value={periodo}
                            onChange={handleChangePeriodo('periodo')}
                            className="form-control"
                        />
                        <small className="text-muted">A média será calculada com base neste período.</small>
                    </FormGroup>
                    <FormGroup>
                        <Label for="arquivo" className="font-weight-bold">Arquivo</Label>
                        <Input
                            id="arquivo"
                            type="file"
                            onChange={e => setFile(e)}
                            className="form-control-file"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-0">
                    <Button color="light" onClick={handleCloseTanques} className="rounded-pill px-4">Cancelar</Button>
                    <Button color="primary" onClick={handleImportTanques} className="rounded-pill px-4 shadow-sm">Importar</Button>
                </ModalFooter>
            </Modal>

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = (state) => {
    return state;
}
const connectedTanquePage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Tanque));
export { connectedTanquePage as Tanque };
